<h5>
  <i eIcon icon="filter"></i>
  Filters
</h5>
<div>
  <span class="font-small">Groep</span>
  <!-- Marge op een wrapper: ng-select kopieert zijn eigen klassen naar de dropdown aan body. -->
  <div class="mt-2">
    <ng-select multiple="true" (change)="updateFilters()" [(ngModel)]="userGroupIds">
      @for (group of (platformUserContext.activeUser$ | async).groups; track group) {
        <ng-option
          [value]="group.id"
          >
          {{ group.name }}
        </ng-option>
      }
    </ng-select>
  </div>
</div>
